class DlFaqs extends HTMLElement {
    constructor() {
        super();
        this.readMoeBtn = this.querySelector('.dl-faqs-container-button');
        this.ul = this.querySelector('.dl-faqs-container-ul');
    }

    connectedCallback() {
        this.init();
    }

    init() {
        this.readMoeBtn.addEventListener('click', this.handleReadMoreClick.bind(this));
    }

    handleReadMoreClick() {
        if (!this.readMoeBtn.classList.contains('dl-for-hide')) {
            this.ul.querySelectorAll('li').forEach((li, index) => {
                if (index >= 5) {
                    li.style.display = 'block';
                }
            });
            this.readMoeBtn.classList.add('dl-for-hide');
        } else {
            this.ul.querySelectorAll('li').forEach((li, index) => {
                if (index >= 5) {
                    li.style.display = 'none';
                }
            });
            this.readMoeBtn.classList.remove('dl-for-hide');
        }
    }
}
customElements.define('dl-faqs', DlFaqs);